import './main.css'
// import javascriptLogo from './images/javascript.svg'
// import viteLogo from './images/logo.svg'
import 'virtual:uno.css'
// import { setupCounter } from './counter.js'
// if you want to change css live in the browser, load these two:
import 'uno.css'
import 'virtual:unocss-devtools'


// On page load or when changing themes, best to add inline in `head` to avoid FOUC
/* if (localStorage.theme === 'dark' || (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
  document.documentElement.classList.add('dark')
} else {
  document.documentElement.classList.remove('dark')
}
if (localStorage.size !== 3) {
  setSize();
}
function setSize() {
  const map = {
    1: 'xsmall',
    2: 'small',
    3: '',
    4: 'large',
    5: 'xlarge',
  }
  document.documentElement.classList.remove('xsmall', 'small', 'large', 'xlarge');
  if (localStorage.size && map[localStorage.size].length) {
    document.documentElement.classList.add(map[localStorage.size]);
  }
}*/

window.toggleDarkMode = function () {
  const currentTheme = localStorage.getItem('theme');
  if (document.documentElement.classList.contains('dark')) {
    document.documentElement.classList.remove(['dark']);
    localStorage.setItem('theme', 'light');
  }
  else {
    document.documentElement.classList.add(['dark']);
    localStorage.setItem('theme', 'dark');
  }
}
window.growText = function() {
  let size = localStorage.size ?? 3;
  if (size > 4) {
    size = 5;
  }
  else {
    size++;
  }
  localStorage.setItem('size', size);
  setSize();
}
window.shrinkText = function () {
  let size = localStorage.size ?? 3;
  if (size < 2) {
    size = 1;
  }
  else {
    size--;
  }
  localStorage.setItem('size', size);
  setSize();
}
